import { ContactAddress, Gender } from "cy-api/simple-payments/common-models";
import { AccountLimit, AccountType } from "cy-remittance/registration";
import { BanknoteIcon, SquareUserRoundIcon } from "lucide-react";
import { z } from "zod";

export const Step = z.enum([
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "password",
  "otp",
  "done",
]);
export type Step = z.infer<typeof Step>;
export const stepFlow: Step[] = [
  "start",
  "accountType",
  "accountLimit",
  "personal",
  "password",
  "otp",
  "done",
];
export interface Country {
  name: string;
  countryCode: string;
  countryCode3: string;
  disabled: boolean;
}
export interface PersonalInfoInputs {
  firstName: string;
  middleName: string;
  lastName: string;
  sourceofFunds?: number | null;
  occupation?: number | null;
  southAfricanId?: string;

  dateOfBirth: {
    day: number;
    month: number;
    year: number;
  };
  gender: Gender;
}

export interface AddressInputs {
  physicalAddress: ContactAddress;
  nationality?: number;
}

export enum AccountTypes {
  SouthAfrican = "south_african",
  ForeignNational = "foreign_national",
}
export const accountTypes: AccountType<AccountTypes>[] = [
  {
    id: AccountTypes.SouthAfrican,
    name: "South African ID Holders",
    label: "South African Four O One",
    description:
      "You will need a copy of your SA Green bar coded ID book or SA Smartcard ID.",
    icon: <SquareUserRoundIcon />,
  },
  {
    id: AccountTypes.ForeignNational,
    name: "Foreign National, residing in South Africa",
    description:
      "You will need a copy of your passport, Asylum seeker permit or Refugee Permit.",
    icon: <SquareUserRoundIcon />,
  },
];

export enum AccountLimits {
  Monthly = "monthly",
  Weekly = "weekly",
}

export function resolveCategoryId({
  accountType,
  accountLimit,
  accountCategories,
}: {
  accountType: AccountType<AccountTypes> | undefined;
  accountLimit: AccountLimit<AccountLimits> | undefined;
  accountCategories: { id: number; name: string }[];
}): number | undefined {
  const label = accountType?.label || accountLimit?.label;
  return accountCategories.find((category) => category.name === label)?.id;
}

export const accountLimits: AccountLimit<AccountLimits>[] = [
  {
    id: AccountLimits.Monthly,
    name: "Monthly",
    label: "Foreign National Four One Seven",
    description: "You will need to provide ID documents and proof of income",
    icon: <BanknoteIcon />,
  },
  {
    id: AccountLimits.Weekly,
    name: "Weekly Wage / Casual Work / Self Employed",
    label: "Foreign National Four One Six",
    description: "You will need to provide ID documents",
    icon: <BanknoteIcon />,
  },
];
